import React from 'react'

import { HiOutlineArrowNarrowRight } from 'react-icons/hi'
import { IconType } from 'react-icons'
import { Container } from './styles'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type: 'button' | 'submit' | 'reset'
  text: string
  icon?: IconType
  prefixIcon?: IconType
}

function Button({
  type = 'button',
  text,
  icon = HiOutlineArrowNarrowRight,
  prefixIcon,
  ...props
}: Props) {
  const PrefixIcon = prefixIcon
  const SuffixIcon = icon

  return (
    <Container type={type} className="button" {...props}>
      {PrefixIcon && <PrefixIcon />}
      {text}
      <SuffixIcon />
    </Container>
  )
}

export default Button
